import { formatInTimeZone, getLocale } from '@lingoda/dates';

// UTC, so the browser's timezone can't shift the stored calendar day.
export const formatDocumentDate = (date: string) => {
    return formatInTimeZone(new Date(date), 'UTC', 'cccc, d MMM yyyy', { locale: getLocale() });
};
